export default __webpack_public_path__ + "static/media/logo-black.f1936d8f.svg";